import React, { useEffect, useRef, useState } from "react";
import { ROOT_URL } from "../../../config/url";
import { useAction, useObject } from "@vokymlak/kabinet-ui";
import { useParams } from "react-router-dom";

function useNomenclature() {
  let { nomenclatureUuid } = useParams();

  const {
    object: [object],
    update: [isUpdateObject, setIsUpdateObject, updateObject],
  } = useObject({
    apiUrl: "/api/nomenclature/" + nomenclatureUuid,
    rootUrl: ROOT_URL,
  });


  useAction(nomenclatureUuid, () => updateObject());

  return {
    object,
    isUpdateObject,
    setIsUpdateObject,
  };
}

export default useNomenclature;
